/**
 * stepper.js — nút cộng trừ số lượng.
 *
 * Markup: [data-stepper] chứa input[data-stepper-input] và hai nút
 *         [data-stepper-down] / [data-stepper-up].
 * Ô nhập vẫn là <input type="number"> nên gõ tay hoặc dùng phím mũi tên đều được;
 * hai nút chỉ là lối tắt cho chuột và cảm ứng.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var steppers = [].slice.call(document.querySelectorAll('[data-stepper]'));
    if (!steppers.length) return;

    steppers.forEach(function (stepper) {
        var input = stepper.querySelector('[data-stepper-input]');
        var down = stepper.querySelector('[data-stepper-down]');
        var up = stepper.querySelector('[data-stepper-up]');
        if (!input) return;

        var min = parseInt(input.getAttribute('min'), 10);
        var max = parseInt(input.getAttribute('max'), 10);
        if (isNaN(min)) min = 1;

        function clamp(value) {
            if (isNaN(value)) value = min;
            if (value < min) value = min;
            if (!isNaN(max) && value > max) value = max;
            return value;
        }

        function change(step) {
            var next = clamp(parseInt(input.value, 10) + step);
            if (String(next) === input.value) return;
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            syncButtons();
        }

        function syncButtons() {
            var value = clamp(parseInt(input.value, 10));
            if (down) down.disabled = value <= min;
            if (up) up.disabled = !isNaN(max) && value >= max;
        }

        if (down) down.addEventListener('click', function () { change(-1); });
        if (up) up.addEventListener('click', function () { change(1); });

        // Gõ tay xong rời ô thì đưa về khoảng hợp lệ
        input.addEventListener('blur', function () {
            input.value = clamp(parseInt(input.value, 10));
            syncButtons();
        });

        syncButtons();
    });
})();
